/**
 * Swiper 10.0.3
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2023 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: July 3, 2023
 */

export { S as Swiper, S as default } from './shared/swiper-core.mjs';



//////////////////
// WEBPACK FOOTER
// ./~/swiper/swiper.mjs
// module id = 1630
// module chunks = 0